/** True when running on production constructinv host (not staging/local). */
export function isProdEnvironment(): boolean {
  if (typeof window === 'undefined') return true
  const host = window.location.hostname
  if (host === 'localhost' || host.includes('127.0.0.1')) return false
  if (host.includes('staging') || host.includes('railway.app')) return false
  if (host.includes('constructinv.varshyl.com') && !host.includes('staging')) return true
  return import.meta.env.PROD === true && !host.includes('staging')
}
